import store from '@/store';
import { getStorage, removeStorage, setStorage } from './storage';
import router from '@/router';

export const getAuthUser = () => getStorage('auth');
export const getToken = () => {
  const user = getAuthUser();
  
  return user?.token || null;
};

export const hasAuthUser = () => !!getToken();

export const logoutAndRedirect = async (redirectPath=null) => {
  removeStorage('auth');
  store.dispatch('setAuth', null);
  const savedLocale = getStorage('locale')
  const browserLocale = navigator.language.startsWith('he') ? 'he' : 'en'
  const lang  = store.getters.locale || savedLocale || browserLocale;
  if(redirectPath){
    router.replace(redirectPath);
  }else{
    window.location.href = (process.env.VUE_APP_ISAVTA_URL || 'https://misgav.isavta.co.il') + '/' + lang+'/salary/welcome';
  }
};

export const bootstrapAuth = (token) => {
  if (!token) return;
  const authData = {
    token: token
  };
  setStorage('auth', authData);
  store.dispatch('setAuth', authData);
};